import { styled, XStack } from "tamagui";

export const IconContainer = styled(XStack, {
  name: "IconContainer",
  backgroundColor: "$transparentBorder",
  padding: 0,
  width: 36,
  height: 36,
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 36,
});
